// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__XFi-_","notes":"Notes_notes__3G6Jm"};